import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CustomLayoutComponent } from "./custom-layout/custom-layout.component";
import { VexRoutes } from "../@vex/interfaces/vex-route.interface";
import { QuicklinkModule, QuicklinkStrategy } from "ngx-quicklink";
import { AuthGuard } from "./service-auth/auth.guard";

const routes: VexRoutes = [
    {
        path: "",
        loadChildren: () =>
            import("./pages/pages/auth/login/login.module").then(
                (m) => m.LoginModule
            ),
    },
    {
        path: "register",
        loadChildren: () =>
            import("./pages/pages/auth/register/register.module").then(
                (m) => m.RegisterModule
            ),
    },
    {
        path: "forgot-password",
        loadChildren: () =>
            import(
                "./pages/pages/auth/forgot-password/forgot-password.module"
            ).then((m) => m.ForgotPasswordModule),
    },
    {
        path: "reset-password",
        loadChildren: () =>
            import(
                "./pages/pages/auth/reset-password/reset-password.module"
            ).then((m) => m.ResetPasswordModule),
    },
    {
        path: "reset-step1",
        loadChildren: () =>
            import(
                "./pages/pages/auth/reset-step1/reset-step1.module"
            ).then((m) => m.ResetStep1Module),
    },
    {
        path: "reset-step2",
        loadChildren: () =>
            import(
                "./pages/pages/auth/reset-step2/reset-step2.module"
            ).then((m) => m.ResetStep2Module),
    },
    {
        path: "coming-soon",
        loadChildren: () =>
            import("./pages/pages/coming-soon/coming-soon.module").then(
                (m) => m.ComingSoonModule
            ),
    },
    {
        path: "",
        component: CustomLayoutComponent,
        children: [
            {
                path: "dashboards/analytics",
                redirectTo: "/",
            },
            {
                path: "dashboard",
                loadChildren: () =>
                    import(
                        "./pages/dashboards/dashboard-analytics/dashboard-analytics.module"
                    ).then((m) => m.DashboardAnalyticsModule),
            },
            {
                path : "reports",
                loadChildren: () =>
                    import( "./pages/apps/report-master/report-master.module").then( (m) => m.ReportMasterModule)
            },

            {
                path : "rmn",
                loadChildren: () =>
                    import( "./pages/apps/rmn/rmn.module").then( (m) => m.RMNComponentModule)
            },


            {
                path: "stores",
                loadChildren: () =>
                    import("./pages/apps/stores/stores.module").then(
                        (m) => m.StoresModule
                    ),
            },
            {
                path: "leads",
                canActivate:[AuthGuard],
                loadChildren: () =>
                    import("./pages/apps/leads/leads.module").then(
                        (m) => m.LeadsModule
                    ),
            },
            {
                path: "campaign/voucher",
                canActivate:[AuthGuard],
                loadChildren: () =>
                    import("./pages/apps/voucher/voucher.module").then(
                        (m) => m.VoucherModule
                    ),
            },
            {
                path: "campaign/reimbursment",
                canActivate:[AuthGuard],
                loadChildren: () =>
                    import("./pages/apps/reimbursement/reimbursement.module").then(
                        (m) => m.ReimbursementModule
                    ),
            },
            {
                path: "content",
                // canActivate:[AuthGuard],
                loadChildren: () =>
                    import("./pages/apps/content-management/content-management.module").then(
                        (m) => m.ContentManagementModule
                    ),
            },
            {
                path: "master",
                loadChildren: () =>
                    import("./pages/apps/master/master.module").then(
                        (m) => m.MasterModule
                    ),
            },
            {
                path: "campaign",
                loadChildren: () =>
                    import("./pages/apps/campaign/campaign.module").then(
                        (m) => m.CampaignModule
                    ),
            },
            {
                path: "report-generate",
                loadChildren: () =>
                    import("./pages/apps/report-generate/report-generate.module").then(
                        (m) => m.ReportGenerateModule
                    ),
            },
            {
                path: "**",
                loadChildren: () =>
                    import(
                        "./pages/pages/errors/error-404/error-404.module"
                    ).then((m) => m.Error404Module),
            }
        ],
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: QuicklinkStrategy,
            scrollPositionRestoration: "enabled",
            relativeLinkResolution: "corrected",
            anchorScrolling: "enabled",
        }),
    ],
    exports: [RouterModule, QuicklinkModule],
})
export class AppRoutingModule {}
